// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorModal_wrapper__42Vey","appear":"ErrorModal_appear__2obJc","openTop":"ErrorModal_openTop__kNjie"};